module.exports = __webpack_public_path__ + "media/מים.56a1b208.mp3";